import { render, staticRenderFns } from "./EditCoffeeSpecies.vue?vue&type=template&id=7a6faa70"
import script from "./EditCoffeeSpecies.vue?vue&type=script&lang=js"
export * from "./EditCoffeeSpecies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports